import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import { Modal,Input,Form } from 'antd';
import './replaceConfireModal.css';
import PropTypes from 'prop-types';

import asReviewWpaFormConfim from '../../public/img/std/asReviewWpaFormConfim.png'
import cancelImg from '../../public/img/newMain/cancel.png';

/**
 * 消息提示组件
 * props传参如下
 * 消息提示类型,样式 ['error','success','warning','info']
 *                              error:错误提示框，红色样式
 *                              success:成功提示框，绿色样式
 *                              warning:警告提示框，黄色样式
 *                              info:普通提示框，蓝色样式
 */
let ReplaceConfireModal = (props, ref) => {

    const [content, setContent] = useState("");
    const [isShow, setIsShow] = useState(false);
    const [form] = Form.useForm();
    useImperativeHandle(ref, () => {
        return {
            setContent,
            setIsShow,
        }
    });

    /**
     * 标题默认值处理
     */
    useEffect(() => {

    }, []);

    const save = ()=>{
        props.done(true);
    }

    const cancel = ()=>{
        props.done(false);
    }

    return (
        <Modal
            open={isShow}
            onCancel={null}
            closeIcon={null}
            footer={null}
            className='deleteFileModal'
            width={735}
            centered
            closable={false}
        >
            <div className='contentBox'>
                {content}
            </div>
            <div className='buttonBox'>
                <div className='websiteSysButton saveButton' onClick={save}><img src={asReviewWpaFormConfim} />Confirm</div>
                <div className='websiteSysButton cancelButton' onClick={cancel}><img src={cancelImg} />Cancel</div>
            </div>
            
        </Modal>
    )

}

ReplaceConfireModal = forwardRef(ReplaceConfireModal);

ReplaceConfireModal.propTypes = {
    done: PropTypes.func.isRequired,
};

export default ReplaceConfireModal;